var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-item',{staticClass:"option-list-item pa-3 mb-2",attrs:{"value":_vm.value},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('div',{class:_vm.getClass(active, hover),on:{"click":toggle}},[_c('div',{staticClass:"subtitle-2 font-weight-bold"},[_vm._t("default")],2),_c('div',{staticClass:"caption"},[_vm._t("caption")],2)])]}}],null,true)})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }